import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { GridHeadeTopActionTemplateDirective } from './grid-header-top-action.template.directive';

@Directive({
  selector: 'grid-header-top-action',
  standalone: false,
})
export class GridHeaderTopActionDirective {
  // @Input()
  @ContentChild(GridHeadeTopActionTemplateDirective, { read: TemplateRef })
  template: TemplateRef<any>;
}
